/**
 * Contact Form Block Frontend Script
 */

class ContactForm {
  constructor(element) {
    this.element = element;
    this.form = element.querySelector('.contact-form');
    this.messageDiv = element.querySelector('.contact-form-message');
    
    this.init();
  }

  init() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit(e);
    });
  }

  async handleSubmit(e) {
    const formData = new FormData(this.form);
    const submitButton = this.form.querySelector('.contact-form-submit');
    const textEl = submitButton.querySelector('.contact-form-submit-text');
    const originalText = textEl ? textEl.textContent : 'Submit';

    // Quitar estados previos de éxito/error
    submitButton.classList.remove('is-success', 'is-error');
    submitButton.disabled = true;
    submitButton.classList.add('is-loading');
    if (textEl) textEl.textContent = 'Sending...';

    try {
      const ajaxUrl = typeof ajaxurl !== 'undefined' ? ajaxurl : this.form.action;
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      submitButton.classList.remove('is-loading');

      if (result.success) {
        const successMessage = result.data?.message || 'Thank you! Your message has been sent successfully.';
        this.showMessage(successMessage, 'success');
        this.form.reset();
        submitButton.classList.add('is-success');
        if (textEl) textEl.textContent = 'Message sent!';
      } else {
        this.showMessage(result.data?.message || result.message || 'An error occurred. Please try again.', 'error');
        submitButton.classList.add('is-error');
        if (textEl) textEl.textContent = originalText;
      }
    } catch (error) {
      console.error('Contact form error:', error);
      this.showMessage('An error occurred. Please try again.', 'error');
      submitButton.classList.remove('is-loading');
      submitButton.classList.add('is-error');
      if (textEl) textEl.textContent = originalText;
    } finally {
      submitButton.disabled = false;
    }
  }

  showMessage(message, type) {
    if (!this.messageDiv) return;

    this.messageDiv.textContent = message;
    this.messageDiv.className = `contact-form-message ${type}`;
    this.messageDiv.style.display = 'block';

    // Hide message after 5 seconds
    setTimeout(() => {
      this.messageDiv.style.display = 'none';
    }, 5000);
  }
}

// Initialize forms when DOM is ready
function initContactForms() {
  const forms = document.querySelectorAll('.block-contact-form');
  forms.forEach((form) => {
    new ContactForm(form);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactForms);
} else {
  initContactForms();
}

if (typeof window !== 'undefined') {
  window.initContactForms = initContactForms;
}

